<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open=false">
					<v-icon medium flat>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="pt-0 event-page__modal-card-text">
				<div>
					<p class="event-page__modal-heading">Cancellation Policy &amp; Terms</p>
					<v-divider class="mt-3 mb-3"></v-divider>
					<p class="event-page-content mb-3">There is a strict refund policy on this event, meaning:</p>
					<p class="event-page-content mb-3 pl-4">Refunds can only be issued in the cases where the host cancels the event, or the event is automatically cancelled due to insufficient interest (e.g. every wrkprty must have at least 5 attendees).</p>
					<p class="event-page-content">For all billing, cancellation, and other policies, please refer to our <a @click="setModalOpen({prop:'termsModal', value: true})">Terms of Service</a></p>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'eventCancellationPolicyModal',
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('eventCancellationPolicyModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventCancellationPolicyModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
